import React from 'react';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';

import images from '../../../assets/images';

const TooltipWithIcon = ({ content, interactive, trigger, theme, placement, srcIcon, type, children, autoClose }) => {
     if (!content) {
          return null;
     }

     const tooltipContent = content.props?.dangerouslySetInnerHTML?.__html || content;

     if (typeof tooltipContent === 'string' && !tooltipContent.trim()) {
          return null;
     }

     const handleAutoClose = (instance) => {
          if (!autoClose) return;

          setTimeout(() => {
               instance.hide();
          }, autoClose);
     };

     return (
          <Tippy
               content={content}
               interactive={interactive}
               trigger={trigger}
               theme={theme}
               placement={placement}
               allowHTML={true}
               onShow={(instance) => handleAutoClose(instance)}
          >
               {type === 'icon' ? (
                    <img src={srcIcon} alt="tooltip icon" className="tooltip-with-icon" />
               ) : (
                    <div className="tooltip-children-wrap">{children}</div>
               )}
          </Tippy>
     );
};

TooltipWithIcon.propTypes = {
     content: PropTypes.node,
     interactive: PropTypes.bool,
     trigger: PropTypes.string,
     theme: PropTypes.string,
     placement: PropTypes.string,
     srcIcon: PropTypes.string,
     type: PropTypes.string,
};

TooltipWithIcon.defaultProps = {
     content: '',
     interactive: true,
     trigger: 'mouseenter focus',
     theme: 'light',
     placement: 'top',
     srcIcon: images.IconsFAinfoCircle,
     type: 'icon',
};

export default TooltipWithIcon;
